import { render, staticRenderFns } from "./ElementsSelectionView.vue?vue&type=template&id=07bf4abd&scoped=true&"
import script from "./ElementsSelectionView.vue?vue&type=script&lang=js&"
export * from "./ElementsSelectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf4abd",
  null
  
)

export default component.exports